import { render } from "./VFeatures.vue?vue&type=template&id=e06a79ac"
import script from "./VFeatures.vue?vue&type=script&lang=ts"
export * from "./VFeatures.vue?vue&type=script&lang=ts"

import "./VFeatures.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script